<div #spcWidget class="chart-widget" [style.height.px]="widgetheight" (dblclick)="resetZoom()"
	(keydown.shift)="onShiftDown($event)" (keyup.shift)="onShiftUp($event)" (keydown.alt)="onAltDown($event)"
	(keyup.alt)="onAltUp($event)" (focusout)="focusOut()" tabindex="1">
	<canvas #graphCanvas id="graphCanvas" (click)="graphClick($event)">{{ graphCanvas }}</canvas>
</div>
